import { post } from "./fetch.core";

// {
//   amount: number;
//   type: "deposit" | "withdrawal";
//   reason: string;
//   createdBy: string;
// }

export async function createManualCashTransaction(payload: any) {
  const res = await post("/pos/manualCashTransaction/create", payload);

  return res.data;
}

export async function listManualCashTransactions(params: {
  paging: {
    size: number;
    page: number;
  };
  date: {
    from: string;
    to: string;
  };
}) {
  if (params.date) {
    //  @ts-ignore
    if (!params.date.from || !params.date.to) delete params.date;
  }

  const res = await post<any>("/pos/manualCashTransaction/list", params);

  return res.data;
}
